import { BreakpointsOptions } from '@mui/material/styles';

export const breakpoints: BreakpointsOptions = {
    values: {
        xs: 0,
        sm: 600, //mobile
        md: 900, //ipad
        lg: 1200,
        xl: 1536,
    }
}